import {
  APP_CONFIG,
  ROUTE_USER_PROFILE,
  ROUTE_HOMEPAGE,
  USER_ACCESS_PERM_TYPES,
} from '@1bill-app/constants';
import { UserQuery } from '@1bill-app/services/user/user.query';
import { UserService } from '@1bill-app/services/user/user.service';
import { ViewMultiUserAccessType } from '@1bill-app/services/user/user.types';
import { Component, OnInit } from '@angular/core';
import { AlertController, ModalController, ToastController } from '@ionic/angular';
import { NGXLogger } from 'ngx-logger';
import { UserManagementModalComponent } from 'src/app/modals/user-management-modal/user-management-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { HomeQuery } from '@1bill-app/services/home/home.query';

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.page.html',
  styleUrls: ['./user-management.page.scss'],
})
export class UserManagementPage implements OnInit {
  userAccessPermTypes = USER_ACCESS_PERM_TYPES;
  defaultHref = ROUTE_USER_PROFILE;

  multiUserAccesses$ = this.userQuery.multiUserAccesses$;
  AccountsCanAccessMeMUA$ = this.userQuery.AccountsCanAccessMeMUA$;
  AccountsICanAccessMUA$ = this.userQuery.AccountsICanAccessMUA$;

  // Used as modal input
  accountsICanAccess: {
    email: string;
    requestStatus: 'APPROVED' | 'SENT' | 'REQUESTED' | 'DENIED';
  }[];

  isLoading$ = this.userQuery.isLoading$;
  public loading$ = this.homeQuery.isLoading$;

  public isPullToRefresh: boolean;

  constructor(
    private userService: UserService,
    private userQuery: UserQuery,
    private homeQuery: HomeQuery,
    private modalCtrl: ModalController,
    private alertController: AlertController,
    private logger: NGXLogger,
    private toastController: ToastController,
    private router: Router,
  ) {}

  async ngOnInit() {
    await this.userService
      .getMultiUserAccesses()
      .toPromise()
      .then((res) => {
        this.logger.log('RES', res);
      });

    this.AccountsICanAccessMUA$.subscribe((muaList) => {
      this.accountsICanAccess = muaList.map((mua) => {
        return { email: mua.accessedUserEmail, requestStatus: mua.requestStatus };
      });
    });

    // console.log('ACCS I CAN ACCESSSSS:', this.accountsICanAccess);
  }

  get userHasFullAccess() {
    return this.userQuery.userHasFullAccess;
  }

  get isAccessingAsOtherUser() {
    return this.userQuery.isAccessingAsOtherUser;
  }

  async openModal(accessTypeIndex) {
    const modal = await this.modalCtrl.create({
      component: UserManagementModalComponent,
      componentProps: {
        accessTypeIndex: accessTypeIndex,
        //accountsICanAccess: this.accountsICanAccess,
      },
    });

    await modal.present();
  }

  getAccessType(accessLevel: string) {
    const lookup = {
      FULL: 0,
      ADD_BILL: 1,
      VIEWER: 2,
    };

    return this.userAccessPermTypes[lookup[accessLevel]];
  }

  async presentAccessAsUser(mua: ViewMultiUserAccessType) {
    await this.userService.activateAccessingAsUser(mua);
    this.router.navigateByUrl(`${ROUTE_HOMEPAGE}`);
  }

  async presentManageInvReq(
    mua: ViewMultiUserAccessType,
    requestType: 'INVITATION' | 'REQUEST',
  ) {
    const textLookup = {
      INVITATION: {
        header: `Accept ${mua.accessedUserName}'s ${mua.accessLevel} access invitation?`,
        description: this.getAccessType(mua.accessLevel).description,
        buttonText: ['Accept', 'Decline'],
      },
      REQUEST: {
        header: `Approve ${mua.accessorUserName}'s ${mua.accessLevel} access request?`,
        description: this.getAccessType(mua.accessLevel).description,
        buttonText: ['Approve', 'Deny'],
      },
    };
    const alert = await this.alertController.create({
      header: textLookup[requestType].header,
      // subHeader: 'Log out',
      message: textLookup[requestType].description,
      buttons: [
        {
          text: textLookup[requestType].buttonText[1],
          handler: (blah) => {
            this.updateMUAReqAndRevokedStatus(
              requestType == 'INVITATION' ? 'REJECTED_INVITATION' : 'DENIED_REQUEST',
              mua,
            );
          },
        },
        {
          text: textLookup[requestType].buttonText[0],
          handler: (blah) => {
            this.updateMUAReqAndRevokedStatus(
              requestType == 'INVITATION' ? 'ACCEPTED_INVITATION' : 'APPROVED_REQUEST',
              mua,
            );
          },
        },
      ],
    });

    await alert.present();
  }

  async presentRevokeAccessAlert(mua: ViewMultiUserAccessType) {
    const alert = await this.alertController.create({
      header: `Remove ${mua.accessorUserName}'s ${mua.accessLevel} access?`,
      // subHeader: 'Log out',
      message: 'They will no longer have any access to your account.',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: (blah) => {},
        },
        {
          text: 'Remove',
          handler: (blah) => {
            this.updateMUAReqAndRevokedStatus('REVOKED_ACCESS', mua);
          },
        },
      ],
    });

    await alert.present();
  }

  /**
   * Handles Approval/Denial of invitations/requests and also when user
   * revokes another user's access to their account
   */
  async updateMUAReqAndRevokedStatus(
    actionPerformed:
      | 'APPROVED_REQUEST'
      | 'ACCEPTED_INVITATION'
      | 'DENIED_REQUEST'
      | 'REJECTED_INVITATION'
      | 'REVOKED_ACCESS'
      | 'REVOKED_INVITATION'
      | 'REVOKED_REQUEST',
    mua: ViewMultiUserAccessType,
  ) {
    // this.logger.log();

    this.userService.updateMUAReqAndRevokedStatus(actionPerformed, mua).subscribe({
      next: (res) => {
        this.logger.log('RESULT:', res);
        this.userService.getMultiUserAccesses().subscribe((res2) => {
          this.logger.log('RES', res2);
        });
      },
      error: (err) => {
        this.logger.log('ERROR:', err);
      },
    });
  }

  async presentToast(color: 'success' | 'danger' | 'warning', message: string) {
    const toast = await this.toastController.create({
      message,
      duration: APP_CONFIG.TOAST_SUCCESS_DURATION,
      color,
      buttons: [
        {
          icon: 'close-circle-outline',
          role: 'cancel',
        },
      ],
    });
    toast.present();
    if (color === 'success') this.userService.getMultiUserAccesses(false);
  }

  doRefresh(event) {
    this.isPullToRefresh = true;
    this.userService.getMultiUserAccesses(true).subscribe({
      next: () => {
        this.isPullToRefresh = false;
        event.target.complete();
      },
      error: () => {
        this.isPullToRefresh = false;
        event.target.complete();
      },
    });
  }
}
